import MemberEventsLandingQuery from '@layouts/member-events-landing/member-events-landing.query'

const MemberEventsLandingPage = (props) => {
  return <MemberEventsLandingQuery {...props} />
}

MemberEventsLandingPage.getInitialProps = async ({ query }) => {
  return ({ query })
}

export default MemberEventsLandingPage
